import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import './index.css';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import { Provider } from 'react-redux';
import store from './store';
import { NotificationsProvider } from '@mantine/notifications';
import { MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';

import App from './App';
import Employees from './pages/system/Employees';
import Jobs from './pages/system/Jobs';
import NotFound from './pages/NotFound';
import Login from './pages/auth/Login';
import User from './pages/auth/User';
import General from './pages/system/General';
import Customers from './pages/system/Customers';
import Vehicles from './pages/system/Vehicles';
import Vehicle from './pages/system/individual/Vehicle';

ReactDOM.render(
  <Provider store={store}>
    <MantineProvider>
      <NotificationsProvider position="top-right">
        <ModalsProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<App />} />
              <Route path="/login" element={<Login title='Login' />} />
              <Route path="/employees" element={<Employees title='Employees' />} />
              <Route path="/jobs" element={<Jobs title='Jobs' />} />
              <Route path='/user' element={<User title='User' />} />
              <Route path='/vehicles' element={<Vehicles title='Vehicles' />} />
              <Route path='/vehicle/:id' element={<Vehicle title='Vehicle' />} />
              <Route path='/customers' element={<Customers title='Customers' />} />
              <Route path='/general' element={<General title='General Settings' />} />
              <Route path="*" element={<NotFound title='Not found' />} />
            </Routes>
          </BrowserRouter>
        </ModalsProvider>
      </NotificationsProvider>
    </MantineProvider>
  </Provider >,
  document.getElementById('root')
);
reportWebVitals();
